module.exports = __webpack_public_path__ + "static/img/apply3.1025430c.png";